import { Grid, Typography } from '@material-ui/core/';
import Link from 'next/link';
import React from 'react';
import useStyles from './Services.style.js';

const SERVICE_TYPES = [
  {
    name: 'delivery',
    icon: '/services/service-type-delivery.png',
    title: 'Delivery',
    description: 'No service Fees, no small cart fees',
  },
  {
    name: 'pickup',
    icon: '/services/service-type-pickup.png',
    title: 'Pick Up',
    description: 'Skip the line and get up to 10% off every pickup order',
  },
  // {
  //   name: 'dine in',
  //   icon: '/services/service-type-dinein.png',
  //   title: 'Dine In',
  //   description: 'Get exclusive dine-in discounts',
  // },
  {
    name: 'grocery',
    icon: '/services/service-type-grocery.png',
    title: 'Grocery',
    description: 'Conveniently delivered to you from your local stores!',
  },
];

const Services = (props) => {
  const { showDescription } = props;
  const classes = useStyles();
  return (
    <Grid container justify='center'>
      <Grid container justify='space-between' className={classes.navigatorContainer}>
        {SERVICE_TYPES.map((serviceType) => (
          <Grid item className={classes.navItem} key={serviceType.name}>
            <Link href={`/services/[service]`} as={`/services/${serviceType.name}`}>
              <a style={{ textDecoration: 'none', color: 'inherit' }}>
                <span
                  style={{
                    display: 'inline-block',
                    height: 150,
                    width: 150,
                    backgroundColor: '#f8f8f8',
                    borderRadius: '50%',
                  }}>
                  <img
                    src={serviceType.icon}
                    alt={`Icon of ${serviceType.title} service`}
                    width='150'
                    height='150'
                    style={{
                      backgroundColor: '#f8f8f8',
                      borderRadius: '50%',
                    }}
                  />
                </span>

                <Typography paragraph className={classes.serviceName}>
                  {serviceType.title}
                </Typography>
                {showDescription && (
                  <Typography style={{ color: '#9b9b9b' }}>{serviceType.description}</Typography>
                )}
              </a>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default Services;
